import React from "react";
import { Button } from "./ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { Download } from "lucide-react";
import { downloadExport } from "../lib/api";
import { toast } from "sonner";

export default function ExportMenu({ dataset, filename, pdfPath, pdfLabel = "PDF Report", params = {}, testId = "export-menu" }) {
  const qs = Object.entries(params)
    .filter(([, v]) => v != null && v !== "" && v !== "all")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
  const suffix = qs ? `&${qs}` : "";
  const run = async (path, fname) => {
    const t = toast.loading("Preparing export…");
    try {
      await downloadExport(path, fname);
      toast.success("Export ready", { id: t });
    } catch {
      toast.error("Export failed", { id: t });
    }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" data-testid={testId}><Download className="h-4 w-4 mr-2" /> Export</Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {dataset && (
          <>
            <DropdownMenuItem data-testid={`${testId}-csv`} onClick={() => run(`/export/${dataset}?format=csv${suffix}`, `${filename}.csv`)}>CSV (.csv)</DropdownMenuItem>
            <DropdownMenuItem data-testid={`${testId}-xlsx`} onClick={() => run(`/export/${dataset}?format=xlsx${suffix}`, `${filename}.xlsx`)}>Excel (.xlsx)</DropdownMenuItem>
          </>
        )}
        {pdfPath && <DropdownMenuItem data-testid={`${testId}-pdf`} onClick={() => run(pdfPath, `${filename}.pdf`)}>{pdfLabel} (.pdf)</DropdownMenuItem>}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
